<template>
  <!-- trigger="click" -->
  <UnSwitcherNew
    swKey="sw_layout_study"
    :hasOpener="false"
    openerIcon="mdi-square"
    @click="scrollCheck"
  >
    <template #item_before="{ item }">
      <div
        class="d-flex mr-2"
        style="height: 1.25rem; width: 1.5rem"
      >
        <LayoutStudy
          :layout="item.payload"
          class="laytsttd_iconified"
          style="gap: 1px; padding: 0"
        >
        </LayoutStudy>
      </div>
    </template>

    <template #menu_after>
      <div class="bt-grey my-1"></div>
      <GwBtns
        :options="options"
        :value="l_tab"
        idKey="payload"
        class="gwbtns_vertical_primary"
        style="--gwbtns-padding: 0"
        @click="handleClick"
      >
        <template #default="{ item }">
          <div class="f-center">
            <div
              :class="item.payload"
              class="swv_layout_spacing mr-2"
              style="height: 1.25rem; width: 1.5rem; --gap: 1px; padding: 0; display: grid"
            >
              <div
                v-for="(i, index) in new Array(item.iconGrid).keys()"
                :key="index"
                class="swv_layout_spacing_item"
              ></div>
            </div>
            {{ $t(`switchers.${item.payload}`) }}
          </div>
        </template>
      </GwBtns>
    </template>
  </UnSwitcherNew>
</template>

<script>
import LayoutStudy from '@/layouts/LayoutStudy'
import GwBtns from '@/components/lib/GwBtns'
import { allSwitchers } from '@/store/switchers/switchers'
import UnSwitcherNew from '@/components/Switchers/UnSwitcher_new'

export default {
  name: 'StudyGroupingSwitcher',
  components: {
    UnSwitcherNew,
    LayoutStudy,
    GwBtns,
  },
  data() {
    this.options = allSwitchers().sw_layout_spacing_study
    return {}
  },
  methods: {
    handleClick(_e, item) {
      this.$store.dispatch('switchers_set_item', {
        key: 'sw_layout_spacing_study',
        item,
      })
      this.scrollCheck()
    },
    scrollCheck() {
      // debugger
      // console.log(this.$store.getters.globals_action)
      this.$store.dispatch('globals_action', `horizontal_scroll_check`)
    },
  },
  computed: {
    l_tab() {
      return this.$store.getters.sw_layout_spacing_study
    },
  },
}
</script>
<style lang="scss" scoped>
.swv_layout_spacing {
  gap: 1px;
  &_item {
    box-shadow: 0px 0px 1px var(--clr-white-0);
  }
  &_large {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
  }
  &_medium {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);
  }
  &_compact {
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(3, 1fr);
  }
}
</style>
